import { useEffect, useState } from "react"
import { Helmet } from "react-helmet-async";
import { Card, CardBody, Col, Container, Row, Spinner } from "reactstrap";
import FilterAdmin from "../../components/FilterAdmin/FilterAdmin";
import CustomDatatable from "../../components/CustomDatatable/CustomDatatable";
import renderFormatedDate from "../../components/RenderCellsDatatable/renderFormatterDate";
import { changePageSizeRegion, cleanMessageRegion, getListaRegion } from "../../store/regions/actions";
import { connect } from "react-redux";
import renderHeader from "../../components/RenderCellsDatatable/renderHeader";
import renderBoolean from "../../components/RenderCellsDatatable/renderBoolean";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { useIsFirstRender } from "../../customHooks/useIsFirstRender";
import { useContextActions } from "../../customHooks/useContextActions";
import ActionButtons from "../../components/ActionButtons/ActionButtons";
import { PAGE_SIZE_OPTIONS } from "../../constants/pagination";

const RegionList = ({ messageRegion, cleanMessageRegion, getListaRegionRequest, loadingRegion, listaRegion, pageSizeRegion, changePageSizeRegion }) => {
  const [objFilter, setObjFilter] = useState({
    createDateStart: null,
    updateDateStart: null,
    createDateEnd: null,
    updateDateEnd: null,
    createUser: null,
    updateUser: null,
    status: true, 
    });
  const [paginationModel, setPaginationModel] = useState({
		pageSize: pageSizeRegion,
		page: 0,
	});
	const navigate = useNavigate();
	const isFistRender = useIsFirstRender();
	const alertModal = withReactContent(Swal);

	const handlePageChange = (model) => {
    const { page, pageSize } = model;
    setPaginationModel({
      pageSize: pageSize,
      page: page,
    });
		changePageSizeRegion(pageSize);

    getListaRegionRequest({
      pageNumber: page + 1,
      pageSize: pageSize,
      createDateStart: objFilter.createDateStart,
      updateDateStart: objFilter.updateDateStart,
      createDateEnd: objFilter.createDateEnd,
      updateDateEnd: objFilter.updateDateEnd,
      createUser: objFilter.createUser,
      updateUser: objFilter.updateUser,
      status: objFilter.status,
      name: objFilter.search
    });
  	};
	const handleSortChange = (model) => {
		console.log(model);
		setTimeout(() => {
			//
		}, 300);
	};
	const handleRowClick = (params, event) => {
		navigate(`/region?id=${params.id}`);
	};

	const actions = useContextActions({
		context: "region",
		screen: "list"
	})
	
	useEffect(() => {
		setPaginationModel(prev => ({
			...prev,
			page: 0
    	}));
		getListaRegionRequest({
			pageNumber: 1,
			pageSize: paginationModel.pageSize,
			createDateStart: objFilter.createDateStart,
			updateDateStart: objFilter.updateDateStart,
			createDateEnd: objFilter.createDateEnd,
			updateDateEnd: objFilter.updateDateEnd,
			createUser: objFilter.createUser,
			updateUser: objFilter.updateUser,
			status: objFilter.status,
			name: objFilter.search
		});

		// eslint-disable-next-line
	}, [objFilter]);
	
	useEffect(() => {
		if (messageRegion) {
			alertModal
				.fire({
					title: `${
						messageRegion !== null
							? messageRegion
							: "Something wrong, try again later."
					}`,
					icon: "error",
					showConfirmButton: false,
					timer: undefined,
					showCloseButton: true,
					timerProgressBar: false,
				})
				.then(() => {
					cleanMessageRegion();
				});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [messageRegion]);

	useEffect(() => {
		return () => {
			cleanMessageRegion();
		};
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
			<div className="page-content">
				<Helmet>
					<title>Regions</title>
				</Helmet>
				<div></div>
				<Container fluid>
					<Row>
						<Col xs={12}>
							<Card>
								<CardBody>
									<div>
										<Row>
											<div className="d-flex justify-content-between my-2">
												<h2>REGION</h2>
												<ActionButtons 
													actions={actions} 
													context="region"	
													handlers={{
														create: () => navigate("/region")
													}}
												/>
											</div>
										</Row>
										<FilterAdmin setObjFilter={setObjFilter} placeholderSearch="Search by region name" isFistRender={isFistRender}/>
										<Row className="my-2">
											{loadingRegion ? (
												<div
													className="d-flex align-items-center justify-content-center"
													style={{ height: "400px", width: "100%" }}
												>
													<Spinner
														color="primary"
														style={{ height: "5rem", width: "5rem" }}
													/>
												</div>
											) : (
												<>
													<CustomDatatable
														columns={columns}
														rows={listaRegion.records}
														rowCount={listaRegion.totalRecords}
														pagination
														paginationMode="server"
														paginationModel={paginationModel}
														onPaginationModelChange={handlePageChange}
														onSortModelChange={handleSortChange}
														onRowClick={handleRowClick}
														pageSizeOptions={PAGE_SIZE_OPTIONS}
														checkboxSelection={false}
														disableColumnFilter
														disableColumnMenu
													/>
												</>
											)}
										</Row>
									</div>
								</CardBody>
							</Card>
						</Col>
					</Row>
				</Container>
			</div>
		);
};

const columns = [
	{
		field: "name",
		headerName: "Name",
		flex: 1,
		sortable: false,
		renderHeader: renderHeader,
	},
	{
		field: "active",
		headerName: "Active Status",
		flex: 1,
		sortable: false,
		renderHeader: renderHeader,
		renderCell: renderBoolean,
		type: "boolean",
	},
	{
		field: "createDate",
		headerName: "Creation Date",
		flex: 1,
		sortable: false,
		renderHeader: renderHeader,
		renderCell: renderFormatedDate,
	},
	{
		field: "updateDate",
		headerName: "Update Date",
		flex: 1,
		sortable: false,
		renderHeader: renderHeader,
		renderCell: renderFormatedDate,
	},
];

const mapStateToProps = ({
	RegionReducer: { loadingRegion, listaRegion, dropdownRegion, messageRegion, pageSizeRegion },
}) => ({
	loadingRegion,
	listaRegion,
	dropdownRegion,
	messageRegion,
	pageSizeRegion,
});

const mapDispatchToProps = {
	getListaRegionRequest: getListaRegion.request,
	cleanMessageRegion,
	changePageSizeRegion,
}

export default connect(mapStateToProps, mapDispatchToProps)(RegionList);